const appdir = window.location.hostname.substr(0, window.location.hostname.indexOf('.'));
const urlid = window.location.href.split('/')[5];

const fetchExhibFloorConfig = () => {
   const url = `https://masterapp.econference.io/masterapp_summer2012/controllers/mobileapp/settings/process_v2.cfm?urlid=${urlid}&appdir=${appdir}`;
   
   // XHR with Firefox workaround (reliable for both Chrome and Firefox)
   return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      let firefoxTimeout = null;
      
      const clearFirefoxTimeout = () => {
         if (firefoxTimeout) {
            clearTimeout(firefoxTimeout);
            firefoxTimeout = null;
         }
      };
      
      const processResponse = () => {
         clearFirefoxTimeout();
         if (xhr.status >= 200 && xhr.status < 300 && xhr.responseText) {
            try {
               resolve(JSON.parse(xhr.responseText));
            } catch (e) {
               if (xhr.readyState !== XMLHttpRequest.DONE) return;
               reject(new Error('Failed to parse JSON: ' + e.message));
            }
         } else if (xhr.readyState === XMLHttpRequest.DONE) {
            reject(new Error(`HTTP error! status: ${xhr.status}`));
         }
      };
      
      xhr.onreadystatechange = () => {
         if (xhr.readyState === XMLHttpRequest.DONE) {
            processResponse();
         } else if (xhr.readyState === XMLHttpRequest.LOADING && xhr.status === 200) {
            const length = xhr.responseText?.length || 0;
            if (length > 0) {
               // Clear any existing timeout
               clearFirefoxTimeout();
               
               // Firefox workaround: Set timeout to process response if stuck in LOADING state
               // This handles Firefox getting stuck at readyState 3 with complete data
               firefoxTimeout = setTimeout(() => {
                  if (xhr.readyState === XMLHttpRequest.LOADING && xhr.status === 200 && xhr.responseText?.length === length) {
                     processResponse();
                  }
               }, 200); // 200ms delay - if still in LOADING with same length, assume complete
            }
         }
      };
      
      xhr.onload = processResponse;
      xhr.onerror = () => { clearFirefoxTimeout(); reject(new Error('XHR network error')); };
      xhr.ontimeout = () => { clearFirefoxTimeout(); reject(new Error('XHR timeout')); };
      
      xhr.open('GET', url, true);
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.timeout = 20000;
      xhr.send();
   });
}


const fetchCompanyDetails = (info) => {
   return new Promise((resolve, reject) => {
      fetch(`https://masterapp.econference.io/masterapp_summer2012/apiv2/index.cfm?appdir=${appdir}&module=company&component=exhibitor_directory&function=exhib_directory_app&conferenceid=${info.conferenceid}`, {
         body: JSON.stringify({ ConfID: info.confid }),
         method: "POST"
      })
         .then(res => res.json())
         .then(result => resolve(result))
         .catch(err => reject(err))
   })
}

const fetchTagsDetails = (info) => {
   let catids = (info?.exhibitor_hall_config?.main_hall_config?.directory_display_config?.tag_catids ?? []);
   return new Promise((resolve, reject) => {
      if(catids && catids.length){
         fetch(`https://bm6uvz69il.execute-api.us-east-1.amazonaws.com/dev/api?module=client&component=tags&function=see_tags&appdir=${info.appdir}&catid=${catids.join()}`)
         .then(res=>res.json())
         .then(result => resolve(result))
         .catch(err => reject(err))
      } else {
         resolve({})
      }
   })
}

const fetchBoothConfigurations = (info) => {
   const {api_url, source_hex, ConfID} = info;
   let sending_data = {
      ConfID: ConfID
   };
   return new Promise((resolve, reject) => {
      fetch(api_url + "?method=getConfiguration&returnFormat=json&Source=" + source_hex, {
         body: JSON.stringify(sending_data),
         method: "POST"
      })
      .then(res=>res.json())
      .then(result => resolve(result))
      .catch(err => reject(err))
   })
}

const exhibFloorAPI = {
   fetchExhibFloorConfig,
   fetchCompanyDetails,
   fetchTagsDetails,
   fetchBoothConfigurations
}
export default exhibFloorAPI
